import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CargoPaymentDetail } from 'src/app/core/interfaces/cargoPayment';
import { AdminUsersService } from 'src/app/modules/administration/admin-users/admin-users.service';
import { UserClient } from 'src/app/core/interfaces/userClient';

export interface TransferredPaymentsDialogData {
  title?: string;
  payments: CargoPaymentDetail[];
}

@Component({
  selector: 'app-transferred-payments-dialog',
  templateUrl: './transferred-payments-dialog.component.html',
  styleUrls: ['./transferred-payments-dialog.component.scss'],
})
export class TransferredPaymentsDialogComponent implements OnInit {
  users = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TransferredPaymentsDialogData,
    public ref: MatDialogRef<TransferredPaymentsDialogComponent>,
    private adminUsersService: AdminUsersService
  ) {}

  ngOnInit(): void {
    (this.payments || []).forEach(payment => {
      const id = payment && payment.userId ? payment.userId : null;
      this.getUser(id);
    });
  }

  get title(): string {
    return (this.data && this.data.title) ? this.data.title : 'Pagos transferidos';
  }

  get payments(): CargoPaymentDetail[] {
    return (this.data && Array.isArray(this.data.payments)) ? this.data.payments : [];
  }

  getUser(id: string) {
    if (!id || this.users[id]) return;
    this.adminUsersService.getUserClientByDocument(id).subscribe(
      (success: UserClient[]) => {
        if (success && success.length) {
          const user = success[0];
          const doc = user && user.information && user.information.document ? user.information.document : id;
          this.users[doc] = user;
        }
      }
    );
  }

  getPaymentTypeLabel(type: string): string {
    if (!type) return '';
    const labels: { [key: string]: string } = {
      advance: 'Anticipo',
      extraAdvance: 'Extra anticipo'
    };
    return labels[type] || type;
  }
}
